import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

const AUTH_CONFIG = {
  sessionKey: 'real_estate_auth_session',
  sessionTimeout: 8 * 60 * 60 * 1000, // 8 horas
  usersStorageKey: 'real_estate_users_db'
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [userTemplate, setUserTemplate] = useState('real_estate');
  const [userRole, setUserRole] = useState('user');
  const [userCompany, setUserCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const getUsersDatabase = () => {
    try {
      const usersData = localStorage.getItem(AUTH_CONFIG.usersStorageKey);
      return usersData ? JSON.parse(usersData) : {};
    } catch (error) {
      console.error('Erro ao carregar banco de usuários:', error);
      return {};
    }
  };

  const checkAuthStatus = () => {
    try {
      const sessionData = localStorage.getItem(AUTH_CONFIG.sessionKey);
      
      if (sessionData) {
        const session = JSON.parse(sessionData);
        const now = new Date().getTime();
        
        if (session.expiresAt && now < session.expiresAt) {
          setIsAuthenticated(true);
          setCurrentUser(session.user);
          setUserTemplate(session.template || 'real_estate');
          setUserRole(session.role || 'user');
          setUserCompany(session.company || null);
        } else {
          logout();
        }
      }
    } catch (error) {
      console.error('Erro ao verificar autenticacao:', error);
      logout();
    } finally {
      setLoading(false);
    }
  };

  const login = (username, password) => {
    const users = getUsersDatabase();
    const user = users[username];
    
    if (user && user.password === password) {
      const now = new Date().getTime();
      const expiresAt = now + AUTH_CONFIG.sessionTimeout;
      
      const sessionData = {
        user: username,
        loginTime: now,
        expiresAt: expiresAt,
        template: user.template || 'real_estate',
        role: user.role || 'user',
        company: user.company || null
      };
      
      localStorage.setItem(AUTH_CONFIG.sessionKey, JSON.stringify(sessionData));
      
      setIsAuthenticated(true);
      setCurrentUser(username);
      setUserTemplate(user.template || 'real_estate');
      setUserRole(user.role || 'user');
      setUserCompany(user.company || null);
      
      return { success: true, message: 'Login realizado com sucesso!' };
    } else {
      return { success: false, message: 'Usuario ou senha incorretos.' };
    }
  };

  const logout = () => {
    localStorage.removeItem(AUTH_CONFIG.sessionKey);
    setIsAuthenticated(false);
    setCurrentUser(null);
    setUserTemplate('real_estate');
    setUserRole('user');
    setUserCompany(null);
  };

  const value = {
    isAuthenticated,
    currentUser,
    userTemplate,
    userRole,
    userCompany,
    loading,
    login,
    logout,
    checkAuthStatus
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  
  if (!context) {
    throw new Error('useAuth deve ser usado dentro de um AuthProvider');
  }
  
  return context;
};